module.exports = __webpack_public_path__ + "img/s1.d26fb793.jpg";